import React from 'react';
import { Navigation24Regular } from '@fluentui/react-icons';
import { Box } from '../../../../theme/fluent';
import { useAppLayoutStyles } from '../../AppLayout.styles';

interface CollapseButtonProps {
    isCollapsed: boolean;
    pureWhiteColor: React.CSSProperties;
    onToggle: () => void;
}

export const CollapseButton: React.FC<CollapseButtonProps> = ({ isCollapsed, pureWhiteColor, onToggle }) => {
    const { classes } = useAppLayoutStyles();

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onToggle();
        }
    };

    return (
        <Box>
            <Box className={classes.collapseButtonSection}>
                <Box
                    className={classes.collapseButton}
                    style={pureWhiteColor}
                    onClick={onToggle}
                    role="button"
                    tabIndex={0}
                    aria-label={isCollapsed ? 'Expand navigation' : 'Collapse navigation'}
                    onKeyDown={handleKeyDown}
                >
                    <Navigation24Regular />
                </Box>
            </Box>
            <Box className={classes.collapseSeparator} />
        </Box>
    );
};
